if (!customElements.get('social-carousel')) {
    class SocialSwiper extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.mySwiper = new Swiper(this.querySelector(`.social_carousel_container`), {
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,
                autoplay: {
                    delay: this.getAttribute('data-gap-time'),
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                observer: true,
                resizeObserver: true,
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                }, 
                pagination: {
                    el: this.querySelector(`.swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`.swiper-scrollbar`),
                    draggable: true,
                },


            });

            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {

        }

        initEvent(swiper) {
            this.querySelector('.pause_btn').addEventListener('click', function () {
                if (this.classList.contains('pause')) {
                    this.classList.remove('pause');
                    swiper.autoplay.start()
                } else {
                    this.classList.add('pause');
                    swiper.autoplay.stop()
                }
            })
        }
    }

    customElements.define('social-carousel', SocialSwiper);
}

